import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import OptionsConstants from '../../constants/other-shipping-options-constants';

import { THIRD_PARTY, RECIPIENT } from '../../enums/bill-to-party';

export const useIsFulfillmentPlanThirdPartyBilling = (serviceId, options) => {
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));

  if (!service?.optionCodes?.includes(OptionsConstants.billToThirdParty)) {
    return false;
  }

  const billToParty = options?.billToAccount?.billToParty;

  return billToParty === THIRD_PARTY || billToParty === RECIPIENT;
};
